import { Location, isPlatformBrowser } from "@angular/common";
import { Component, Inject, LOCALE_ID, PLATFORM_ID } from "@angular/core";
import { MatIconRegistry, MatIcon } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LanguageService } from "src/app/_services/language.service";
import { environment } from "src/environments/environment";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { Angulartics2OnModule } from "angulartics2";
import { MatIconButton } from "@angular/material/button";

@Component({
    selector: 'language-selector',
    templateUrl: './language.component.html',
    imports: [
        MatMenu,
        MatMenuItem,
        Angulartics2OnModule,
        MatIcon,
        MatIconButton,
        MatMenuTrigger,
    ],
})
export class LanguageComponent {
  
  selectedLanguageCountry: string;
  currentURI: string;
  
  private static LANGUAGE_TO_COUNTRY: Map<string, string> = new Map([
    ['et', 'ee'],
    ['ru', 'ru'],
    ['en-US', 'gb']
  ]);
    
  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private router: Router,
    private location: Location,
    private languageService: LanguageService,
    @Inject(LOCALE_ID) locale: string,
    ) {

    const assetsURL = environment.assetsBaseURL;
    
    console.log("Adding flag SVG icons");          
    iconRegistry.addSvgIcon('flag-gb', sanitizer.bypassSecurityTrustResourceUrl(`${assetsURL}/svg-country-flags/svg/gb.svg`));  
    iconRegistry.addSvgIcon('flag-ee', sanitizer.bypassSecurityTrustResourceUrl(`${assetsURL}/svg-country-flags/svg/ee.svg`));
    iconRegistry.addSvgIcon('flag-ru', sanitizer.bypassSecurityTrustResourceUrl(`${assetsURL}/svg-country-flags/svg/ru.svg`));
    console.log("Finished adding SVG flag icons"); 
    
    this.router.events.subscribe(() => {
      this.currentURI = this.location.path();
    });
    
    this.selectedLanguageCountry = LanguageComponent.LANGUAGE_TO_COUNTRY.get(locale)!;
  }
  
  select(language: string) {
    this.languageService.storePreferredLanguage(language);
    window.location.href = `/${language}${this.currentURI}`;
  }
}
